/**
 * The auth provider's error NAME (e.g. `UsernameExistsException`, `CodeMismatchException`)
 * for funnel failure events. Never the message: Cognito messages can echo the email.
 * A plain `Error` or a non-error throw reports as `unknown`.
 */
export function authErrorName(err: unknown): string {
  const name = (err as { name?: unknown } | null)?.name
  return typeof name === 'string' && name !== '' && name !== 'Error' ? name : 'unknown'
}
